import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTanzaniaFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8527_36162)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9835 4.03229C9.92869 6.95165 5.83531 11.2822 3.2049 16.4931C0.574499 21.7041 -0.478678 27.5693 0.174427 33.3699L47.7962 5.87628C43.0994 2.40951 37.4932 0.388481 31.6648 0.0609391C25.8364 -0.266603 20.039 1.11358 14.9835 4.03229Z",
				fill: "#83BF4F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.1769 54.1554C16.8735 57.6218 22.4794 59.6426 28.3075 59.97C34.1355 60.2974 39.9325 58.9172 44.9878 55.9986C50.043 53.08 54.1368 48.7498 56.7674 43.5388C59.3979 38.3279 60.4509 32.4627 59.7973 26.6621L12.1769 54.1554Z",
				fill: "#428BC1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.9694 15.0137C54.6141 12.6728 52.9477 10.5265 51.0157 8.6333L0.954834 37.5383C2.30278 42.8034 5.07038 47.5974 8.95588 51.3976L59.017 22.4932C58.3443 19.8736 57.3191 17.3575 55.9694 15.0137Z",
				fill: "#3E4347"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.4851 24.5323C59.3583 23.8495 59.1929 23.1703 59.017 22.4922L8.95587 51.3966C9.45392 51.8866 9.95999 52.3694 10.4883 52.8205C11.0363 53.2897 11.6012 53.7306 12.1769 54.1554L59.7959 26.6621C59.716 25.951 59.6172 25.2401 59.4851 24.5323Z",
				fill: "#FFCE31"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.4833 7.20971C48.9362 6.74192 48.3718 6.29992 47.7961 5.87598L0.174347 33.3696C0.254253 34.0804 0.354418 34.7912 0.486763 35.499C0.613288 36.1821 0.778652 36.86 0.954837 37.5381L51.0157 8.63391C50.5163 8.1428 50.0119 7.66086 49.4833 7.20971Z",
				fill: "#FFCE31"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8527_36162",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 60,
			height: 60,
			fill: "white",
			transform: "translate(0 0.000488281)"
		})
	}) })]
});
export default SvgTanzaniaFlag;
